// extracted by css-extract-rspack-plugin
export default {"wrapper":"ErrorInfo_wrapper__AEhvq","footer":"ErrorInfo_footer__+H4GZ"};